import React, { useEffect } from "react";
import SelectField from "../../../library/components/Select";
import { useState } from "react";
import { useGetEpbGenerationDownloadCeoReportQuery } from "../../../services/reportsServices";
import pdfIcon from "../../../images/pdfIcon.png"
import excelIcon from "../../../images/excelIcon.png"
import Table from "../../../ui/datatable/DataTable";
import { downloadExcelFile, downloadPdfFile } from "../../utilities/utils"
import LeftMenu from "../../AnalyticsModule/Left";
import RunnerUpHeaderNew from "../../../ui/runnerUpHeader/RunnerUpHeaderNew";

const tableHeader = [
  "State name",
  "AC/PC No. and Name",
  "e-PB PIN Transmission Status",
  "Total e-PB generated",
  "Total e-PB downloaded",
  // "Total e-PB booked",
];

const selectConstituencyType = [
  { value: "AC", label: "AC" },
  { value: "PC", label: "PC" },
];

const EpbGenerationDownloadCeoReport = () => {
  const [totalNoOfRecords, setTotalNoOfRecords] = useState()
  const [data, setData] = useState({
    constituencyType: "AC",
  });
  // const reportName = "e-Postal Ballot Generation/downloading/booked report"
  // const SheetName = "Generation/downloading/booked Report"
  const reportName = "e-Postal Ballot Generation/downloading Report"
  const SheetName = "Generation/downloading Report"
  const tableHeader = [];
  const columns = [
    {
      Header: "State Name",
      accessor: "col1",
    },
    {
      Header: "AC/PC No. and Name",
      accessor: "col2",
    },
    {
      Header: "e-PB PIN Transmission Status",
      accessor: "col3",
    },
    {
      Header: "Total e-PB generated",
      accessor: "col4",
    },
    {
      Header: "Total e-PB downloaded",
      accessor: "col5",
    },
    // {
    //   Header: "Total e-PB booked",
    //   accessor: "col6",
    // },
  ];
  columns.map((item) => {
    tableHeader.push(item.Header)
  })
  const [tabledata, setTabledata] = useState([]);
  const [skip, setskip] = useState(false);

  const { data: responseData} = useGetEpbGenerationDownloadCeoReportQuery( data.constituencyType);

  const handleChange = (key, value) => {
    setData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
    setskip(false);
  };

 

  useEffect(() => {
    var tableData = [];
    if (responseData != null) {
      responseData?.payload?.map((item) => {
        tableData.push({
          "col1": item.stateName,
          "col2": `${item.acPcNo}-${item.acPcName}`,
          "col3": item.epbGenerationStatus,
          "col4": item.generatedEpbCount,
          "col5": item.downloadedEpbCount,
          // "col6": item.epbBooked,
        });
      });
      setTabledata(tableData);
      setTotalNoOfRecords(responseData?.payload?.length)
      setskip(true);
    }
  }, [responseData]);

  return (
    <LeftMenu>
    <div className="container-fluid box shadow ">
      <RunnerUpHeaderNew 
      title={reportName}
      state={responseData?.state}
      onExcelClick={() => downloadExcelFile(reportName, SheetName, tableHeader, tabledata,true)}
      onPdfClick={() => downloadPdfFile(reportName, tableHeader, tabledata, false, true)}
      />
 
      <div className="row">
        <SelectField
          labelClass=""
          inputClass="col-md-2"
          value={data.constituencyType}
          handleChange={(val) => handleChange("constituencyType", val)}
          options={selectConstituencyType}
        />
      </div>
      <div style={{ marginTop: "-40px" }}>
        <Table
          placeholder="Search"
          globalsearch={true}
          selectall={true}
          emptyMessage="No Record Found"
          columns={columns}
          data={tabledata?.length === 0 ? [] : tabledata}
          size={5}
          tableClassNameCheck="contenttable-eroll"
          pagination    
          records
          gotopage
          rows
          numberrows={totalNoOfRecords}
        />
      </div>
    </div>
  </LeftMenu>
  );
};
export default EpbGenerationDownloadCeoReport;
